enum TransferSettingIntegration {
  NETS = 'NETS',
  STRIPE = 'Stripe',
  ZIMPLER = 'Zimpler',
  NONE = 'None',
}
export default TransferSettingIntegration
